export const SOL_ADDRESS = "11111111111111111111111111111111";
export const SOL_MINT = "So11111111111111111111111111111111111111112";
export const USDC_MINT = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const LAMPORTS_PER_SOL = 1_000_000_000;
export const DEFAULT_SLIPPAGE_BPS = 50;

export const TOKEN_COLORS: Record<string, string> = {
	SOL: "linear-gradient(135deg,#9945ff,#14f195)",
	USDC: "linear-gradient(135deg,#2775ca,#5b9eff)",
	USDT: "linear-gradient(135deg,#26a17b,#5fe2b3)",
	JUP: "linear-gradient(135deg,#ffb84d,#ff7a59)",
	JTO: "linear-gradient(135deg,#ff5e7a,#ff8a3d)",
	BONK: "linear-gradient(135deg,#ffdd00,#ff8a3d)",
	WIF: "linear-gradient(135deg,#ff8ad7,#bb74ff)",
	PYTH: "linear-gradient(135deg,#241f3f,#7b5cff)",
	RAY: "linear-gradient(135deg,#3b59fb,#22ccff)",
	MSOL: "linear-gradient(135deg,#7b5cff,#22ccff)",
	ORCA: "linear-gradient(135deg,#ffb84d,#ff5e7a)",
	RENDER: "linear-gradient(135deg,#1f1f1f,#7b5cff)",
};

export function getTokenColor(symbol: string): string {
	return TOKEN_COLORS[symbol] ?? "linear-gradient(135deg,#6a6a76,#9a9aa6)";
}

export function fmtNumber(n: number | undefined | null, max = 4): string {
	const v = Number(n);
	if (!isFinite(v) || v === 0) return "0";
	if (v < 0.0001) return v.toExponential(2);
	if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(2)}M`;
	if (v >= 1000) return v.toLocaleString("en-US", { maximumFractionDigits: 2 });
	return v.toLocaleString("en-US", { maximumFractionDigits: max });
}

export function fmtUsd(n: number | undefined | null): string {
	const v = Number(n);
	if (!isFinite(v) || v === 0) return "$0.00";
	if (v < 0.01) return "<$0.01";
	if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(2)}M`;
	return "$" + v.toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
}

export function shortAddr(addr: string): string {
	if (addr.length <= 14) return addr;
	return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

export function isSolanaAddress(addr: string): boolean {
	return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(addr.trim());
}

export function lamportsToSol(lamports: number): number {
	return lamports / LAMPORTS_PER_SOL;
}

export function solToLamports(sol: number): number {
	return Math.round(sol * LAMPORTS_PER_SOL);
}

export function tokenAmountToRaw(amount: number, decimals: number): bigint {
	return BigInt(Math.round(amount * 10 ** decimals));
}

export function rawToTokenAmount(raw: bigint | number, decimals: number): number {
	return Number(raw) / 10 ** decimals;
}

export function solscanTxUrl(signature: string): string {
	return `https://solscan.io/tx/${signature}`;
}

export function solscanAccountUrl(address: string): string {
	return `https://solscan.io/account/${address}`;
}
